import { render, staticRenderFns } from "./FormMemberFamily.vue?vue&type=template&id=3aa4c8a3"
import script from "./FormMemberFamily.vue?vue&type=script&lang=js"
export * from "./FormMemberFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports